import React from 'react';

export const ArrowLeftIcon: React.FC = () => {
  return (
    <svg width='14' height='12' viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7 12H5.25V10.2857H3.5V8.57143H1.75V6.85714H0V5.14286H1.75V3.42857H3.5V1.71429H5.25V0H7V3.42857H14V8.57143H7V12Z'
        fill='white'
      />
    </svg>
  );
};
export const GroupIcon: React.FC = () => {
  return (
    <svg width='23' height='24' viewBox='0 0 23 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.66781 19.6708V20.6234H3.85742V17.7656H4.81002V19.6708H7.66781Z' fill='black' />
      <path d='M19.1 17.7656V20.6234H16.2422V19.6708H18.1474V17.7656H19.1Z' fill='black' />
      <path
        d='M15.2893 20.6233V22.5285H8.62109V20.6233H9.57369V19.6707H11.4789V18.7181H10.5263V17.7655H9.57369V14.9077H10.5263V13.9551H13.3841V14.9077H14.3367V17.7655H13.3841V18.7181H12.4315V19.6707H14.3367V20.6233H15.2893Z'
        fill='black'
      />
      <path
        d='M21.9592 14.9074V16.8126H15.291V14.9074H16.2436V13.9548H18.1488V13.0022H17.1962V12.0496H16.2436V9.19186H17.1962V8.23926H20.054V9.19186H21.0066V12.0496H20.054V13.0022H19.1014V13.9548H21.0066V14.9074H21.9592Z'
        fill='black'
      />
      <path
        d='M7.66818 14.9074V16.8126H1V14.9074H1.9526V13.9548H3.85779V13.0022H2.90519V12.0496H1.9526V9.19186H2.90519V8.23926H5.76299V9.19186H6.71558V12.0496H5.76299V13.0022H4.81039V13.9548H6.71558V14.9074H7.66818Z'
        fill='black'
      />
      <path d='M7.66781 3.47559V4.42818H4.81002V7.28598H3.85742V3.47559H7.66781Z' fill='black' />
      <path d='M19.1009 3.47559V7.28598H18.1483V4.42818H14.3379V3.47559H19.1009Z' fill='black' />
      <path
        d='M14.3381 8.23947V10.1447H7.66992V8.23947H8.62252V7.28687H10.5277V6.33428H9.57512V5.38168H8.62252V2.52389H9.57512V1.57129H12.4329V2.52389H13.3855V5.38168H12.4329V6.33428H11.4803V7.28687H13.3855V8.23947H14.3381Z'
        fill='black'
      />
    </svg>
  );
};

export const SendIcon: React.FC = () => {
  return (
    <svg width='33' height='33' viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_dii_256_3746)'>
        <path
          d='M28.95 9.14H30.48V12.19H32V19.81H30.48V22.86H28.95V25.9H27.43V27.43H25.9V28.95H22.86V30.48H19.81V32H12.19V30.48H9.14V28.95H6.09V27.43H4.57V25.9H3.05V22.86H1.52V19.81H0V12.19H1.52V9.14H3.05V6.09H4.57V4.57H6.09V3.05H9.14V1.52H12.19V0H19.81V1.52H22.86V3.05H25.9V4.57H27.43V6.09H28.95V9.14Z'
          fill='#D9D9D9'
        />
        <path
          d='M19.3096 0.5V2.01953H22.3604V3.5498H25.4004V5.07031H26.9297V6.58984H28.4502V9.63965H29.9805V12.6904H31.5V19.3096H29.9805V22.3604H28.4502V25.4004H26.9297V26.9297H25.4004V28.4502H22.3604V29.9805H19.3096V31.5H12.6904V29.9805H9.63965V28.4502H6.58984V26.9297H5.07031V25.4004H3.5498V22.3604H2.01953V19.3096H0.5V12.6904H2.01953V9.63965H3.5498V6.58984H5.07031V5.07031H6.58984V3.5498H9.63965V2.01953H12.6904V0.5H19.3096Z'
          stroke='black'
        />
      </g>
      <path
        d='M9 15.1111L9 13.3333L11 13.3333L11 11.5556L13 11.5556L13 9.77778L15 9.77778L15 8L17 8L17 9.77778L19 9.77778L19 11.5556L21 11.5556L21 13.3333L23 13.3333L23 15.1111L19 15.1111L19 22.2222L13 22.2222L13 15.1111L9 15.1111Z'
        fill='black'
      />
      <rect x='9.77734' y='20.4443' width='8.88889' height='2.66667' fill='black' />
      <defs>
        <filter
          id='filter0_dii_256_3746'
          x='0'
          y='0'
          width='33'
          height='33'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='1' dy='1' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_256_3746' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_256_3746' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='2' dy='2' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0' />
          <feBlend mode='normal' in2='shape' result='effect2_innerShadow_256_3746' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-2' dy='-2' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 1 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_256_3746' result='effect3_innerShadow_256_3746' />
        </filter>
      </defs>
    </svg>
  );
};

export const BroomIcon: React.FC = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M30.4688 30.5039H31.9987V32H30.4688V30.5039Z' fill='black' />
      <path d='M27.4219 27.502H28.9519V28.998H27.4219V27.502Z' fill='black' />
      <path d='M27.4219 12.502H28.9519V15.5039H27.4219V12.502Z' fill='black' />
      <path d='M25.8984 15.5039H27.4184V17H25.8984V15.5039Z' fill='black' />
      <path d='M25.8984 11.0059H27.4184V12.5019H25.8984V11.0059Z' fill='black' />
      <path d='M24.3828 30.5039H25.9028V32H24.3828V30.5039Z' fill='black' />
      <path d='M24.3828 17H25.9028V18.5059H24.3828V17Z' fill='black' />
      <path d='M24.3828 9.5H25.9028V11.0059H24.3828V9.5Z' fill='black' />
      <path d='M22.8516 27.502H24.3816V28.998H22.8516V27.502Z' fill='black' />
      <path d='M22.8516 18.5059H24.3816V20.0019H22.8516V18.5059Z' fill='black' />
      <path d='M22.8516 8.00391H24.3816V9.49997H22.8516V8.00391Z' fill='black' />
      <path d='M21.3281 20.002H22.8481V21.498H21.3281V20.002Z' fill='black' />
      <path d='M21.3281 6.49805H22.8481V8.00395H21.3281V6.49805Z' fill='black' />
      <path d='M19.8047 28.998H21.3347V30.504H19.8047V28.998Z' fill='black' />
      <path d='M19.8047 21.498H21.3347V23.004H19.8047V21.498Z' fill='black' />
      <path d='M19.8047 5.00195H21.3347V6.49802H19.8047V5.00195Z' fill='black' />
      <path d='M18.2812 23.0039H19.8013V24.5H18.2812V23.0039Z' fill='black' />
      <path d='M18.2812 12.502H19.8013V13.998H18.2812V12.502Z' fill='black' />
      <path d='M18.2812 3.50586H19.8013V5.00192H18.2812V3.50586Z' fill='black' />
      <path d='M16.7578 24.5H18.2778V25.9961H16.7578V24.5Z' fill='black' />
      <path d='M15.2266 2H18.2766V3.50591H15.2266V2Z' fill='black' />
      <path d='M15.2266 25.9961H16.7566V27.502H15.2266V25.9961Z' fill='black' />
      <path d='M15.2266 15.5039H18.2766V17H15.2266V15.5039Z' fill='black' />
      <path d='M15.2266 9.5H16.7566V11.0059H15.2266V9.5Z' fill='black' />
      <path d='M13.7109 24.5H15.2309V25.9961H13.7109V24.5Z' fill='black' />
      <path d='M13.7109 13.998H15.2309V15.504H13.7109V13.998Z' fill='black' />
      <path d='M13.7109 3.50586H15.2309V5.00192H13.7109V3.50586Z' fill='black' />
      <path d='M12.1875 25.9961H13.7075V27.502H12.1875V25.9961Z' fill='black' />
      <path d='M12.1875 23.0039H13.7075V24.5H12.1875V23.0039Z' fill='black' />
      <path d='M12.1875 11.0059H13.7075V13.998H12.1875V11.0059Z' fill='black' />
      <path d='M12.1875 5.00195H13.7075V6.49802H12.1875V5.00195Z' fill='black' />
      <path d='M10.6641 21.498H12.1941V23.004H10.6641V21.498Z' fill='black' />
      <path d='M10.6641 6.49805H12.1941V8.00395H10.6641V6.49805Z' fill='black' />
      <path
        d='M6.09 30.5039H7.61V32H18.28V30.5039H15.23V28.998H12.19V27.502H6.09V28.998H1.52V30.5039H0V32H6.09V30.5039Z'
        fill='black'
      />
      <path d='M9.14062 20.002H10.6606V21.498H9.14062V20.002Z' fill='black' />
      <path d='M9.14062 8.00391H10.6606V9.49997H9.14062V8.00391Z' fill='black' />
      <path d='M7.60938 18.5059H9.13937V20.0019H7.60938V18.5059Z' fill='black' />
      <path d='M7.60938 9.5H9.13937V11.0059H7.60938V9.5Z' fill='black' />
      <path d='M6.08594 17H7.60594V18.5059H6.08594V17Z' fill='black' />
      <path d='M6.08594 11.0059H7.60594V12.5019H6.08594V11.0059Z' fill='black' />
      <path d='M4.57031 25.9961H6.09031V27.502H4.57031V25.9961Z' fill='black' />
      <path d='M4.57031 15.5039H6.09031V17H4.57031V15.5039Z' fill='black' />
      <path d='M4.57031 12.502H6.09031V13.998H4.57031V12.502Z' fill='black' />
      <path d='M3.03906 24.5H4.56906V25.9961H3.03906V24.5Z' fill='black' />
      <path d='M3.03906 17H4.56906V18.5059H3.03906V17Z' fill='black' />
      <path d='M3.03906 13.998H4.56906V15.504H3.03906V13.998Z' fill='black' />
      <path d='M1.52344 23.0039H3.04344V24.5H1.52344V23.0039Z' fill='black' />
      <path d='M1.52344 18.5059H3.04344V20.0019H1.52344V18.5059Z' fill='black' />
      <path d='M0 20.002H1.52V23.0039H0V20.002Z' fill='black' />
    </svg>
  );
};

export const QRCodeIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.5 2.5H13V13H2.5V2.5ZM4.5 4.5V11H11V4.5H4.5ZM15 2.5H21.5V9H15V2.5ZM17 4.5V7H19.5V4.5H17ZM6 6H9.5V9.5H6V6ZM18.5 11H21.5V13H18.5V11ZM2.5 15H9V21.5H2.5V15ZM15 11H17V13H15V11ZM4.5 17V19.5H7V17H4.5ZM15 15H21.5V21.5H15V15ZM17 17V19.5H19.5V17H17ZM11 17V15H13V17H11ZM11 21.5V18.5H13V21.5H11Z'
        fill='black'
      />
    </svg>
  );
};

export const SmallBroomIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M22.8516 22.8779H23.9991V24H22.8516V22.8779Z' fill='black' />
      <path d='M20.5664 20.6265H21.7139V21.7485H20.5664V20.6265Z' fill='black' />
      <path d='M20.5664 9.37646H21.7139V11.6279H20.5664V9.37646Z' fill='black' />
      <path d='M19.4238 11.6279H20.5638V12.75H19.4238V11.6279Z' fill='black' />
      <path d='M19.4238 8.25439H20.5638V9.37644H19.4238V8.25439Z' fill='black' />
      <path d='M18.2871 22.8779H19.4271V24H18.2871V22.8779Z' fill='black' />
      <path d='M18.2871 12.75H19.4271V13.8794H18.2871V12.75Z' fill='black' />
      <path d='M18.2871 7.125H19.4271V8.25443H18.2871V7.125Z' fill='black' />
      <path d='M17.1387 20.6265H18.2862V21.7485H17.1387V20.6265Z' fill='black' />
      <path d='M17.1387 13.8794H18.2862V15.0014H17.1387V13.8794Z' fill='black' />
      <path d='M17.1387 6.00293H18.2862V7.12498H17.1387V6.00293Z' fill='black' />
      <path d='M15.9961 15.0015H17.1361V16.1235H15.9961V15.0015Z' fill='black' />
      <path d='M15.9961 4.87354H17.1361V6.00296H15.9961V4.87354Z' fill='black' />
      <path d='M14.8535 21.7485H16.001V22.878H14.8535V21.7485Z' fill='black' />
      <path d='M14.8535 16.1235H16.001V17.253H14.8535V16.1235Z' fill='black' />
      <path d='M14.8535 3.75146H16.001V4.87351H14.8535V3.75146Z' fill='black' />
      <path d='M13.7109 17.2529H14.8509V18.375H13.7109V17.2529Z' fill='black' />
      <path d='M13.7109 9.37646H14.8509V10.4985H13.7109V9.37646Z' fill='black' />
      <path d='M13.7109 2.62939H14.8509V3.75144H13.7109V2.62939Z' fill='black' />
      <path d='M12.5684 18.375H13.7084V19.497H12.5684V18.375Z' fill='black' />
      <path d='M11.4199 1.5H13.7074V2.62943H11.4199V1.5Z' fill='black' />
      <path d='M11.4199 19.4971H12.5674V20.6265H11.4199V19.4971Z' fill='black' />
      <path d='M11.4199 11.6279H13.7074V12.75H11.4199V11.6279Z' fill='black' />
      <path d='M11.4199 7.125H12.5674V8.25443H11.4199V7.125Z' fill='black' />
      <path d='M10.2832 18.375H11.4232V19.497H10.2832V18.375Z' fill='black' />
      <path d='M10.2832 10.4985H11.4232V11.628H10.2832V10.4985Z' fill='black' />
      <path d='M10.2832 2.62939H11.4232V3.75144H10.2832V2.62939Z' fill='black' />
      <path d='M9.14062 19.4971H10.2806V20.6265H9.14062V19.4971Z' fill='black' />
      <path d='M9.14062 17.2529H10.2806V18.375H9.14062V17.2529Z' fill='black' />
      <path d='M9.14062 8.25439H10.2806V10.4985H9.14062V8.25439Z' fill='black' />
      <path d='M9.14062 3.75146H10.2806V4.87351H9.14062V3.75146Z' fill='black' />
      <path d='M7.99805 16.1235H9.14555V17.253H7.99805V16.1235Z' fill='black' />
      <path d='M7.99805 4.87354H9.14555V6.00296H7.99805V4.87354Z' fill='black' />
      <path
        d='M4.5675 22.8779H5.7075V24H13.71V22.8779H11.4225V21.7485H9.1425V20.6265H4.5675V21.7485H1.14V22.8779H0V24H4.5675V22.8779Z'
        fill='black'
      />
      <path d='M6.85547 15.0015H7.99547V16.1235H6.85547V15.0015Z' fill='black' />
      <path d='M6.85547 6.00293H7.99547V7.12498H6.85547V6.00293Z' fill='black' />
      <path d='M5.70703 13.8794H6.85453V15.0014H5.70703V13.8794Z' fill='black' />
      <path d='M5.70703 7.125H6.85453V8.25443H5.70703V7.125Z' fill='black' />
      <path d='M4.56445 12.75H5.70445V13.8794H4.56445V12.75Z' fill='black' />
      <path d='M4.56445 8.25439H5.70445V9.37644H4.56445V8.25439Z' fill='black' />
      <path d='M3.42773 19.4971H4.56773V20.6265H3.42773V19.4971Z' fill='black' />
      <path d='M3.42773 11.6279H4.56773V12.75H3.42773V11.6279Z' fill='black' />
      <path d='M3.42773 9.37646H4.56773V10.4985H3.42773V9.37646Z' fill='black' />
      <path d='M2.2793 18.375H3.4268V19.497H2.2793V18.375Z' fill='black' />
      <path d='M2.2793 12.75H3.4268V13.8794H2.2793V12.75Z' fill='black' />
      <path d='M2.2793 10.4985H3.4268V11.628H2.2793V10.4985Z' fill='black' />
      <path d='M1.14258 17.2529H2.28258V18.375H1.14258V17.2529Z' fill='black' />
      <path d='M1.14258 13.8794H2.28258V15.0014H1.14258V13.8794Z' fill='black' />
      <path d='M0 15.0015H1.14V17.2529H0V15.0015Z' fill='black' />
    </svg>
  );
};

export const TrashIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.4276 6.28496V18.855H20.5751V6.28496H22.8551V5.14496H21.7151V3.99746H17.1401V1.70996H16.0001V3.99746H7.99758V1.70996H6.85758V3.99746H2.29008V5.14496H1.14258V6.28496H3.43008V18.855H4.57008V6.28496H19.4276ZM18.2876 18.855H19.4276V22.2825H18.2876V18.855ZM5.71758 22.2825H18.2876V23.43H5.71758V22.2825Z'
        fill='black'
      />
      <path
        d='M16.0003 8.57232H17.1403V17.7148H16.0003V8.57232ZM14.8603 17.7148H16.0003V19.9948H14.8603V17.7148ZM11.4328 8.57232H12.5728V19.9948H11.4328V8.57232ZM7.99781 0.569824H16.0003V1.70982H7.99781V0.569824ZM7.99781 17.7148H9.14531V19.9948H7.99781V17.7148ZM6.85781 8.57232H7.99781V17.7148H6.85781V8.57232ZM4.57031 18.8548H5.71781V22.2823H4.57031V18.8548Z'
        fill='black'
      />
    </svg>
  );
};

export const Trash2Icon: React.FC = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M25.9034 8.38027V25.1403H27.4334V8.38027H30.4734V6.86027H28.9534V5.33027H22.8534V2.28027H21.3334V5.33027H10.6634V2.28027H9.14344V5.33027H3.05344V6.86027H1.52344V8.38027H4.57344V25.1403H6.09344V8.38027H25.9034ZM24.3834 25.1403H25.9034V29.7103H24.3834V25.1403ZM7.62344 29.7103H24.3834V31.2403H7.62344V29.7103Z'
        fill='black'
      />
      <path
        d='M21.3337 11.4298H22.8538V23.6198H21.3337V11.4298ZM19.8138 23.6198H21.3337V26.6598H19.8138V23.6198ZM15.2437 11.4298H16.7638V26.6598H15.2437V11.4298ZM10.6638 0.759766H21.3337V2.27977H10.6638V0.759766ZM10.6638 23.6198H12.1937V26.6598H10.6638V23.6198ZM9.14375 11.4298H10.6638V23.6198H9.14375V11.4298ZM6.09375 25.1398H7.62375V29.7098H6.09375V25.1398Z'
        fill='black'
      />
    </svg>
  );
};

export const KeyIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.7145 3.4275H18.8545V9.1425H17.7145V3.4275ZM16.567 19.4325H17.7145V20.5725H16.567V19.4325ZM16.567 14.8575H17.7145V15.9975H16.567V14.8575ZM16.567 9.1425H17.7145V10.2825H16.567V9.1425ZM16.567 2.2875H17.7145V3.4275H16.567V2.2875ZM15.427 10.2825H16.567V11.43H15.427V10.2825ZM15.427 1.14H16.567V2.2875H15.427V1.14ZM13.1395 20.5725V22.86H14.287V21.7125H16.567V20.5725H13.1395ZM13.1395 15.9975V19.4325H16.567V18.285H14.287V17.145H16.567V15.9975H13.1395ZM15.427 12.57V11.43H13.1395V14.8575H16.567V13.7175H14.287V12.57H15.427ZM13.1395 5.715H14.287V3.4275H13.1395V4.575H11.9995V3.4275H13.1395V2.2875H10.852V3.4275H9.71203V5.715H10.852V6.855H13.1395V5.715ZM10.852 22.86H13.1395V24H10.852V22.86ZM10.852 11.43H8.57203V12.57H9.71203V22.86H10.852V11.43ZM8.57203 0H15.427V1.14H8.57203V0ZM7.42453 10.2825H8.57203V11.43H7.42453V10.2825ZM7.42453 1.14H8.57203V2.2875H7.42453V1.14ZM6.28453 9.1425H7.42453V10.2825H6.28453V9.1425ZM6.28453 2.2875H7.42453V3.4275H6.28453V2.2875ZM5.14453 3.4275H6.28453V9.1425H5.14453V3.4275Z'
        fill='black'
      />
    </svg>
  );
};

export const PixelCrownIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.287 6.85893H23.427V9.13893H22.287V6.85893ZM19.9995 5.71143H22.287V6.85893H19.9995V5.71143ZM19.9995 13.7139H21.147V10.2864H22.287V9.13893H19.9995V6.85893H18.8595V10.2864H19.9995V13.7139ZM18.8595 14.8539H17.712V16.0014H18.8595V17.1414H5.14195V16.0014H6.28945V14.8539H5.14195V13.7139H4.00195V19.4289H5.14195V20.5689H18.8595V19.4289H19.9995V13.7139H18.8595V14.8539ZM17.712 10.2864H18.8595V11.4264H17.712V10.2864ZM16.572 11.4264H17.712V12.5739H16.572V11.4264ZM15.432 12.5739H16.572V13.7139H15.432V12.5739Z'
        fill='black'
      />
      <path
        d='M14.2842 14.8537H16.5717V16.0012H14.2842V14.8537ZM14.2842 10.2862H15.4317V12.5737H14.2842V10.2862ZM13.1442 7.99865H14.2842V10.2862H13.1442V7.99865ZM13.1442 4.57115H14.2842V6.85865H13.1442V4.57115ZM10.8567 6.85865H13.1442V7.99865H10.8567V6.85865ZM10.8567 3.43115H13.1442V4.57115H10.8567V3.43115ZM10.8567 13.7137H13.1442V16.0012H10.8567V13.7137ZM9.71672 7.99865H10.8567V10.2862H9.71672V7.99865ZM9.71672 4.57115H10.8567V6.85865H9.71672V4.57115ZM8.56922 10.2862H9.71672V12.5737H8.56922V10.2862ZM7.42922 14.8537H9.71672V16.0012H7.42922V14.8537ZM7.42922 12.5737H8.56922V13.7137H7.42922V12.5737ZM6.28922 11.4262H7.42922V12.5737H6.28922V11.4262ZM5.14172 10.2862H6.28922V11.4262H5.14172V10.2862ZM1.71422 9.13865V10.2862H2.86172V13.7137H4.00172V10.2862H5.14172V6.85865H4.00172V9.13865H1.71422ZM1.71422 5.71115H4.00172V6.85865H1.71422V5.71115ZM0.574219 6.85865H1.71422V9.13865H0.574219V6.85865Z'
        fill='black'
      />
    </svg>
  );
};

export const QuestionIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_224_12151)'>
        <path
          d='M22.86 9.1425H24V14.8575H22.86V9.1425ZM21.7125 14.8575H22.86V17.145H21.7125V14.8575ZM21.7125 6.855H22.86V9.1425H21.7125V6.855ZM20.5725 17.145H21.7125V19.425H20.5725V17.145ZM20.5725 4.5675H21.7125V6.855H20.5725V4.5675ZM19.425 19.425H20.5725V20.5725H19.425V19.425ZM19.425 3.4275H20.5725V4.5675H19.425V3.4275ZM17.145 20.5725H19.425V21.7125H17.145V20.5725ZM17.145 2.2875H19.425V3.4275H17.145V2.2875ZM14.8575 21.7125H17.145V22.86H14.8575V21.7125ZM15.9975 4.5675H14.8575V3.4275H9.1425V4.5675H8.0025V5.715H6.855V9.1425H9.1425V6.855H10.2825V5.715H12.57V6.855H13.7175V9.1425H12.57V10.2825H11.43V11.43H10.2825V13.7175H13.7175V12.57H14.8575V11.43H15.9975V10.2825H17.145V5.715H15.9975V4.5675ZM14.8575 1.14H17.145V2.2875H14.8575V1.14ZM9.1425 22.86H14.8575V24H9.1425V22.86ZM13.7175 14.8575H10.2825V15.9975H9.1425V19.425H10.2825V20.5725H13.7175V19.425H14.8575V15.9975H13.7175V14.8575ZM9.1425 0H14.8575V1.14H9.1425V0ZM6.855 21.7125H9.1425V22.86H6.855V21.7125ZM6.855 1.14H9.1425V2.2875H6.855V1.14ZM4.5675 20.5725H6.855V21.7125H4.5675V20.5725ZM4.5675 2.2875H6.855V3.4275H4.5675V2.2875ZM3.4275 19.425H4.5675V20.5725H3.4275V19.425ZM3.4275 3.4275H4.5675V4.5675H3.4275V3.4275ZM2.2875 17.145H3.4275V19.425H2.2875V17.145ZM2.2875 4.5675H3.4275V6.855H2.2875V4.5675ZM1.14 14.8575H2.2875V17.145H1.14V14.8575ZM1.14 6.855H2.2875V9.1425H1.14V6.855ZM0 9.1425H1.14V14.8575H0V9.1425Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_224_12151'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExitIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_224_13029)'>
        <path
          d='M18.8559 6.85514V10.2826H14.2809V12.5701H18.8559V15.9976H19.9959V14.8576H21.1434V13.7176H22.2834V12.5701H23.4234V10.2826H22.2834V9.14264H21.1434V8.00264H19.9959V6.85514H18.8559ZM15.4284 15.9976H16.5684V20.5726H15.4284V15.9976ZM15.4284 1.14014H16.5684V6.85514H15.4284V1.14014ZM10.8534 22.8601V21.7126H15.4284V20.5726H10.8534V5.71514H9.71344V22.8601H10.8534ZM6.28594 22.8601H9.71344V24.0001H6.28594V22.8601ZM7.42594 12.5701H8.56594V14.8576H7.42594V12.5701ZM7.42594 4.57514H9.71344V5.71514H7.42594V4.57514ZM3.99844 21.7126H6.28594V22.8601H3.99844V21.7126ZM5.13844 3.42764H7.42594V4.57514H5.13844V3.42764ZM1.71094 20.5726H3.99844V21.7126H1.71094V20.5726ZM2.85844 2.28764H5.13844V3.42764H2.85844V2.28764Z'
          fill='black'
        />
        <path d='M1.71422 0V1.14H0.574219V20.5725H1.71422V2.2875H2.86172V1.14H15.4317V0H1.71422Z' fill='black' />
      </g>
      <defs>
        <clipPath id='clip0_224_13029'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ChatsIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.5722 11.4299V12.5699H14.2847V13.7174H7.42969V14.8574H10.8572V15.9974H11.9972V17.1449H13.1447V18.2849H17.7122V19.4249H18.8597V20.5724H19.9997V21.7124H21.1397V17.1449H22.2872V15.9974H23.4272V11.4299H22.2872V10.2824H21.1397V9.14238H18.8597V5.71488H17.7122V11.4299H16.5722ZM16.5722 4.56738H17.7122V5.71488H16.5722V4.56738Z'
        fill='black'
      />
      <path
        d='M13.1459 8.0026H15.4259V10.2826H13.1459V8.0026ZM14.2859 3.4276H16.5734V4.5676H14.2859V3.4276ZM8.57086 8.0026H10.8584V10.2826H8.57086V8.0026ZM6.28336 14.8576H7.43086V15.9976H6.28336V14.8576ZM5.14336 2.2876H14.2859V3.4276H5.14336V2.2876ZM5.14336 13.7176H4.00336V18.2851H5.14336V17.1451H6.28336V15.9976H5.14336V13.7176ZM4.00336 8.0026H6.28336V10.2826H4.00336V8.0026ZM2.85586 3.4276H5.14336V4.5676H2.85586V3.4276ZM2.85586 12.5701H4.00336V13.7176H2.85586V12.5701ZM1.71586 11.4301H2.85586V12.5701H1.71586V11.4301ZM1.71586 4.5676H2.85586V5.7151H1.71586V4.5676ZM0.568359 5.7151H1.71586V11.4301H0.568359V5.7151Z'
        fill='black'
      />
    </svg>
  );
};

export const SearchIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.99805 2H13.998V4H5.99805V2ZM3.99805 6V4H5.99805V6H3.99805ZM3.99805 14H1.99805V6H3.99805V14ZM5.99805 16H3.99805V14H5.99805V16ZM13.998 16V18H5.99805V16H13.998ZM15.998 14H13.998V16H15.998V18H17.998V20H19.998V22H21.998V20H19.998V18H17.998V16H15.998V14ZM15.998 6H17.998V14H15.998V6ZM15.998 6V4H13.998V6H15.998Z'
        fill='black'
      />
    </svg>
  );
};

export const RandomIcon: React.FC = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.1414 23.4298V22.2898H15.4214V21.1423H17.7089V20.0023H19.9964V18.8548H21.1364V17.7148H22.2839V6.28482H21.1364V5.14482H19.9964V6.28482H17.7089V7.43232H15.4214V8.57232H13.1414V9.71233H10.8539V10.8598H11.9977V22.2898H10.8577V23.4298H13.1414ZM17.7089 9.71233H19.9964V10.8598H17.7089V9.71233ZM14.2814 16.5748H16.5727V18.8548H14.2852L14.2814 16.5748ZM17.7089 4.00482H19.9964V5.14482H17.7089V4.00482ZM15.4214 2.85732H17.7089V4.00482H15.4214V2.85732ZM13.1414 1.71732H15.4214V2.85732H13.1414V1.71732ZM10.8539 5.14482H13.1414V7.43232H10.8539V5.14482ZM10.8539 0.569824H13.1414V1.71732H10.8539V0.569824ZM8.56641 21.1423H10.8539V22.2898H8.56641V21.1423Z'
        fill='black'
      />
      <path
        d='M8.56594 8.57277H10.8534V9.71277H8.56594V8.57277ZM8.56594 1.71777H10.8534V2.85777H8.56594V1.71777ZM8.56594 16.5753H10.8534V18.8553H8.56594V16.5753ZM8.56594 12.0003H10.8534V14.2878H8.56594V12.0003ZM6.27844 20.0028H8.56594V21.1428H6.27844V20.0028ZM6.27844 7.43277H8.56594V8.57277H6.27844V7.43277ZM6.27844 2.85777H8.56594V4.00527H6.27844V2.85777ZM3.99844 18.8553H6.27844V20.0028H3.99844V18.8553ZM3.99844 6.28527H6.27844V7.43277H3.99844V6.28527ZM3.99844 4.00527H6.27844V5.14527H3.99844V4.00527ZM3.99844 14.2878H6.27844V16.5753H3.99844V14.2878ZM3.99844 9.71277H6.27844V12.0003H3.99844V9.71277ZM2.85094 17.7153H3.99844V18.8553H2.85094V17.7153ZM2.85094 5.14527H3.99844V6.28527H2.85094V5.14527ZM1.71094 6.28527H2.85094V17.7153H1.71094V6.28527Z'
        fill='black'
      />
    </svg>
  );
};

export const ThunderballSimpleIcon: React.FC = () => {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_40_10045)'>
        <path d='M37.1406 10.4756H39.0531V12.3756H37.1406V10.4756Z' fill='black' />
        <path d='M35.2383 12.375H37.1383V14.2875H35.2383V12.375Z' fill='black' />
        <path d='M35.2383 8.5752H37.1383V10.4752H35.2383V8.5752Z' fill='black' />
        <path d='M33.3379 10.4756H35.2379V12.3756H33.3379V10.4756Z' fill='black' />
        <path
          d='M33.3379 35.2379V33.3254H35.2379V31.4254H33.3379V29.5254H31.4254V31.4254H29.5254V33.3254H31.4254V35.2379H33.3379Z'
          fill='black'
        />
        <path d='M31.4277 16.188H33.3402V20.0005H31.4277V16.188Z' fill='black' />
        <path d='M29.5254 20H31.4254V21.9H29.5254V20Z' fill='black' />
        <path d='M29.5254 4.7627H31.4254V6.6627H29.5254V4.7627Z' fill='black' />
        <path d='M27.6152 21.9004H29.5277V23.8129H27.6152V21.9004Z' fill='black' />
        <path d='M27.6152 6.6626H29.5277V8.5751H27.6152V6.6626Z' fill='black' />
        <path d='M25.7148 23.8125H27.6148V25.7125H25.7148V23.8125Z' fill='black' />
        <path d='M25.7148 8.5752H27.6148V10.4752H25.7148V8.5752Z' fill='black' />
        <path d='M23.8125 25.7129H25.7125V27.6129H23.8125V25.7129Z' fill='black' />
        <path d='M23.8125 10.4756H25.7125V12.3756H23.8125V10.4756Z' fill='black' />
        <path d='M21.9023 37.1382H23.8148V39.0507H21.9023V37.1382Z' fill='black' />
        <path d='M21.9023 27.6128H23.8148V29.5253H21.9023V27.6128Z' fill='black' />
        <path d='M21.902 12.375V14.2875H20.002V16.1875H31.427V14.2875H23.8145V12.375H21.902Z' fill='black' />
        <path d='M20.002 29.5254H21.902V31.4254H20.002V29.5254Z' fill='black' />
        <path d='M31.4246 2.8502V4.7627H33.3371V0.950195H18.0996V2.8502H31.4246Z' fill='black' />
        <path d='M18.0996 31.4248H19.9996V33.3248H18.0996V31.4248Z' fill='black' />
        <path d='M16.1895 33.3252H18.102V35.2377H16.1895V33.3252Z' fill='black' />
        <path d='M16.1895 2.8501H18.102V4.7626H16.1895V2.8501Z' fill='black' />
        <path d='M14.2891 35.2378H16.1891V37.1378H14.2891V35.2378Z' fill='black' />
        <path d='M16.1887 20H4.76367V21.9H14.2887V25.7125H16.1887V20Z' fill='black' />
        <path d='M14.2891 4.7627H16.1891V6.6627H14.2891V4.7627Z' fill='black' />
        <path d='M12.377 37.1377H14.2895V39.0502H12.377V37.1377Z' fill='black' />
        <path d='M12.377 25.7129H14.2895V31.4254H12.377V25.7129Z' fill='black' />
        <path d='M12.377 6.66309H14.2895V8.57559H12.377V6.66309Z' fill='black' />
        <path d='M10.4766 31.4253H12.3766V37.1378H10.4766V31.4253Z' fill='black' />
        <path d='M10.4766 8.5752H12.3766V10.4752H10.4766V8.5752Z' fill='black' />
        <path d='M8.57617 10.4756H10.4762V12.3756H8.57617V10.4756Z' fill='black' />
        <path d='M6.66406 12.375H8.57656V14.2875H6.66406V12.375Z' fill='black' />
        <path d='M4.76367 27.6128H6.66367V29.5253H4.76367V27.6128Z' fill='black' />
        <path d='M4.76367 14.2876H6.66367V16.1876H4.76367V14.2876Z' fill='black' />
        <path
          d='M4.76523 0.950195V2.8502H2.86523V4.7627H4.76523V6.6627H6.66523V4.7627H8.57773V2.8502H6.66523V0.950195H4.76523Z'
          fill='black'
        />
        <path d='M2.86523 29.5254H4.76523V31.4254H2.86523V29.5254Z' fill='black' />
        <path d='M2.86523 25.7129H4.76523V27.6129H2.86523V25.7129Z' fill='black' />
        <path d='M2.86523 16.188H4.76523V20.0005H2.86523V16.188Z' fill='black' />
        <path d='M0.951172 27.6128H2.86367V29.5253H0.951172V27.6128Z' fill='black' />
      </g>
      <defs>
        <clipPath id='clip0_40_10045'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
